import { socket } from "../index";

const listenAck = (
  callback: (...args: any[]) => void
) => {
  socket?.on('ACK', callback);
}

export default listenAck;